import { inject, Injectable } from '@angular/core';
import { ApiService } from '@move-frontend/portal-toolkit';
import { AppContextService } from './app-context.service';

// Routes API calls to the active app's backend URL by overriding portal-toolkit's
// static `env.apiUrl` with the per-app URL resolved through AppContextService.
@Injectable({ providedIn: 'root' })
export class AppApiService extends ApiService {
  private appContext: AppContextService = inject(AppContextService);

  public override get apiUrl(): string {
    return this.appContext.apiUrl() ?? '';
  }
}
